import React, { useState } from "react";
import { Container } from "vComponents";
import { StripeCardForm, Button } from "components";
import { css } from "react-emotion";
import { FormControlLabel, Radio, RadioGroup } from "@material-ui/core";

const titleStyle = css`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  line-height: 18px;
  margin-right: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const mdcButton = css`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
  box-shadow: rgba(120, 120, 120, 0.5) 3px 3px 13px;
`;

function PaymentDetails({ style, billingInfo, couponId, plan, ...props }) {
  const [loading, setLoading] = useState(false);

  const [terms, setTerms] = useState(false);
  const [commitment, setCommitment] = useState(null);

  const toggleAgreeToTerms = () => {
    setTerms(!terms);
  };

  const handleChange = (e) => {
    setCommitment(e.target.value);
  };

  // console.log("disable Button: " + buttonControl);

  return (
    <Container style={style}>
      <div
        style={{
          display: "flex",
        }}
      >
        <h3>Payment Details</h3>
        {loading && (
          <img
            style={{
              width: "20px",
              marginLeft: "10px",
            }}
            src="https://mobile360-assets.s3.us-east-2.amazonaws.com/loading.gif"
          />
        )}
      </div>
      <StripeCardForm
        billingInfo={billingInfo}
        couponId={couponId}
        setLoading={setLoading}
        plan={plan}
        {...props}
      ></StripeCardForm>
    </Container>
  );
}

export default PaymentDetails;
